import {
  Component,
  OnInit,
  EventEmitter,
  ViewChild,
  Pipe,
  PipeTransform,
  OnDestroy,
} from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AngularFireDatabase } from "@angular/fire/database";
import { Profile } from "../../Models/profile.interface";
import { LessonIntro } from "../../Models/lessonIntro.interface";
import { UserManager } from "../../Services/UserManager/user-manager";
import "rxjs/add/operator/take";
import { GlobalVariablesService } from "../../Services/globalVariables/global-variables.service";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";
import { ScrollService } from "../../Services/ScrollManager/scroll.service";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { LessonCard } from "../../Models/lessons.interface";
import { LessonManagerService } from "../../Services/LessonManager/lesson-manager.service";
import { DomSanitizer } from "@angular/platform-browser";
import { Location } from "@angular/common";
import { Subject } from "rxjs";
import { VgApiService } from "@videogular/ngx-videogular/core";
import { HttpClient } from "@angular/common/http";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";

@Component({
  selector: "app-lesson-header",
  templateUrl: "./lesson-header.component.html",
  styleUrls: ["./lesson-header.component.css"],
  animations: [
    trigger("all", [
      state(
        "show",
        style({
          opacity: 1,
        })
      ),
      state(
        "void",
        style({
          opacity: 0,
        })
      ),
      transition("void => show", [
        style({ opacity: 0 }),
        animate("400ms 400ms ease-out"),
      ]),
      transition("show => *", [
        style({ opacity: 1 }),
        animate("200ms 200ms ease-out"),
      ]),
    ]),
  ],
})
export class LessonHeaderComponent implements OnInit, OnDestroy {
  config;
  id: string = "1";
  title: string;
  img: string;
  lessonCard: LessonCard;
  intro: LessonIntro;
  welcomeMessage: string;
  unlockedObservable: Observable<Object>;
  unlocked: boolean = false;
  unlockSubscription: Subscription;
  previousUnlocked: number = 1;
  profile: Profile;
  profileSubscription: Subscription;
  leaving = new Subject();
  anonymous;
  bypassed;
  done = new EventEmitter();
  safeVideo = {};
  video;
  currentState = "void";
  api: VgApiService;
  loggedIn = false;

  get lessonNumber(): number {
    return Number(this.id) || 0;
  }

  get questionsRoot(): string {
    return this.config?.questionsRoot || "Questions";
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private db: AngularFireDatabase,
    public um: UserManager,
    private gv: GlobalVariablesService,
    private scroll: ScrollService,
    private lm: LessonManagerService,
    private securityOverride: DomSanitizer,
    private lc: Location,
    private http: HttpClient,
    private ls: LanguageSwitchService
  ) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
      },
    });
  }

  ngOnInit() {
    this.load();
    if (this.id === "1") {
      this.scroll.scrollToElement("#lesson1Heading");
    } else {
      this.scroll.scrollToElement("#LessonIntro");
    }
    this.db
      .object(`Videos/Lesson${this.id}`)
      .valueChanges()
      .take(1)
      .subscribe(async (video) => {
        let response = await this.http
          .get(String(video), { responseType: "text", observe: "response" })
          .toPromise();
        this.video = response.url;
        console.log(this.video);
      });
  }

  async load() {
    this.id = this.route.snapshot.paramMap.get("id") ?? "1";
    this.title = this.route.snapshot.paramMap.get("title");
    this.img = this.route.snapshot.paramMap.get("img");
    let user = await this.um.isLoggedIn();
    this.loggedIn = !!user;
    this.lc.replaceState(`/lesson-header?id=${this.id}`);
    if (!this.id) {
      this.lessonCard = this.lm.getCard(1);
    } else {
      this.lessonCard = this.lm.getCard(+this.id);
    }
    this.gv.print(
      `id = ${this.id}, title = ${this.title}, img string = ${this.img}`
    );

    this.unlocked = this.id === "1" ? true : false;
    this.db
      .object<LessonIntro>(
        `${this.questionsRoot}/${this.id}/${this.id}-0`
      )
      .valueChanges()
      .take(1)
      .subscribe((intro) => {
        if (intro) {
          this.intro = intro;
          this.currentState = "show";
        }
      });

    this.um
      .getUnlockObjectSubject()
      .takeUntil(this.leaving)
      .subscribe((unlockObject) => {
        // console.log(this.unlockedObservable)
        this.um.getPreviousUnlocked(+this.id).then((pu) => {
          this.previousUnlocked = pu;
        });
        if (unlockObject[this.id]) {
          this.unlocked = unlockObject[this.id];
        }
      });

    this.um
      .getProfileSubject()
      .takeUntil(this.leaving)
      .subscribe((profile) => {
        this.profile = profile;
        if (profile) {
          this.anonymous = profile.anonymous;
          this.bypassed = profile.bypassed;
        }
      });
  }

  onPlayerReady = (api: VgApiService) => {
    this.api = api;
  };

  ngOnDestroy() {
    this.leaving.next();
  }
  gotoLesson() {
    this.um.gotoLesson(+this.id, null).catch((e) => console.error(e));
  }

  gotoLessonHeader(lesson: number) {
    this.done
      .take(1)
      .subscribe((_) =>
        this.um.gotoLessonHeader(lesson).then((_) => this.load())
      );
    this.currentState = "void";
  }
  next(e) {
    if (e.phaseName === "done" && e.toState === "void") {
      // console.log('emitting')
      this.done.emit(null);
    }
  }
}
